var _formattedCurrentTime=0;

/**
 * Set the format time
 * @param {object} videojs 
 * @param {timestamp} timestamp 
 * @param {string} format 
 */
export function setFormatTime(videojs,timestamp,format){
  //update videojs tooltip
  videojs.getComponent('TimeTooltip').prototype.updateTime = function update(){
    //set style and time value
    this.el().style.left = "100%";
    this.el().innerHTML = _replaceTimeFormat(format,_setCurrentPlaybackTime(timestamp,this));
  };

  //update videojs mouse tooltip using Video.Js API
  videojs.getComponent('MouseTimeDisplay').prototype.update = function update(position,currentTimePercentage) {
    //get the passed timestamp and convert into a data object
    let selectedTime=new Date((timestamp+(this.player_.duration()*currentTimePercentage)) * 1000);
    //set style and time value
    this.el().style.left = currentTimePercentage*100 + '%';
    let tooltip = document.getElementsByClassName("vjs-time-tooltip");
    Array.prototype.forEach.call(tooltip, function(el) {
      el.innerHTML=_replaceTimeFormat(format,selectedTime);
    });
  };

  //update videojs duration label using Video.Js API
  videojs.getComponent('DurationDisplay').prototype.updateContent = function updateContent() {
    let selectedTime=new Date((timestamp+(this.player_.duration())) * 1000);
    this.el().innerHTML = _replaceTimeFormat(format,selectedTime);
  };

  //update videojs current time label using Video.Js API and set the formatted current time
  videojs.getComponent('CurrentTimeDisplay').prototype.updateContent = function updateContent() {
    this.el().innerHTML = _replaceTimeFormat(format,_setCurrentPlaybackTime(timestamp,this));
    _formattedCurrentTime = this.el().innerHTML;
  };
  
}

/**
 * Return the current formatted time
 * @returns 
 */
export function getFormattedCurrentTime(){
  return _formattedCurrentTime;
}

/**
 * Calculate the current playback time
 * @param {timestamp} timestamp 
 * @param {object} vjs 
 * @returns 
 */
function _setCurrentPlaybackTime(timestamp,vjs){
  try{
    //get the passed timestamp and convert into a data object
    const date = new Date(timestamp * 1000);
    //get the current playback seconds using the progress bar properties and add it to the absolute time
    let currentPlayerTime=vjs.player().controlBar.progressControl.seekBar.duration_/vjs.player().controlBar.progressControl.seekBar.el_.clientWidth*vjs.player().controlBar.progressControl.seekBar.bar.timeTooltip.el_.offsetLeft;
    //set the new time
    let newDate=new Date(date);
    newDate.setSeconds(date.getSeconds() + currentPlayerTime);
    return newDate;
  }catch(error){
    return new Date();
  }
}

/**
 * Replace the format string with a date
 * @param {string} format 
 * @param {date} date 
 * @returns 
 */
function _replaceTimeFormat(format,date) {
  try{
    format=format.replace("Y",date.getFullYear());
    format=format.replace("m",("0" + date.getMonth()).slice(-2));
    format=format.replace("n",date.getMonth());
    format=format.replace("d",("0" + date.getDate()).slice(-2));
    format=format.replace("j",date.getDate());
    format=format.replace("H",("0" + date.getHours()).slice(-2));
    format=format.replace("G",date.getHours());
    format=format.replace("i",("0" + date.getMinutes()).slice(-2));
    format=format.replace("s",("0" + date.getSeconds()).slice(-2));
  }catch(error){format="0";}
  return format;
}